module.exports = "* {\r\n    font-family: Roboto;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/intro/intro.component.css
// module id = ./src/app/intro/intro.component.css
// module chunks = main